<template>
  <div class="card" v-if="isShow()" id="promocode">
    <div class="card-body">
      <div class="divide-y">
        <label class="row">
          <span class="col-4">
            <span class="title" style="">Промокод</span>
          </span>
          <span class="col-8">
            <input v-model="fields.val" type="text" class="form-control" placeholder="Промокод" @change="changeItem">
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref} from "vue"
import "./css/style.css"

export default defineComponent({
  name: "Promocode",
  components: {},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)

    const fields = reactive({
      val: null,
    })

    onMounted(async () => {
      updateFields(props.payload)

      markUnshow()
      markShow()
    })

    function updateFields(query) {
      fields.val = query.val
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function changeItem(e) {
      pushEvent(e.target.value)
    }

    function pushEvent(val) {
      emit("onChange", val)
    }

    return {
      isShow,
      fields,
      changeItem,
    }
  }
})
</script>

<style scoped>

</style>
